import React from "react";
import './style.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../content/css/site.css';
import MenuLink from '../utilities/MenuLink';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram } from '@fortawesome/free-brands-svg-icons';
import paymentMethod from '../content/img/payment-method.png';
import companyLogo from '../content/img/logo-w.png';
import { HashLink as LinkHash } from 'react-router-hash-link';
import Newsletter from "./Newsletter";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";



const Footer = () => {
  const {t} = useTranslation();

  return (
    <footer className="background-black">
      <div className="footer-margin-bottom">
        <Newsletter />
      </div>
      <div className="container custom-width">
        <div className="row text-center text-white">
          <div className="col-md-12 p-5 mb-4">
            <img className="logo-footer" src={companyLogo} alt="Feeling Italy logo"/>
          </div>
        </div>
        <div className="row pt-3">
          <div className="col-lg-4 col-md-6 col-12 p-3 customSectionFooter">
            <h5 className="text-uppercase header-footer mb-35">{t("Services")}</h5>
            {MenuLink.map((item, index) =>
              item.position === "Footer" && item.section === "Services" && item.show ? (
                <div key={index}>
                  {item.anchor ? (
                    <LinkHash className={`${item.class ? item.class : ""}`} smooth to={item.href} target={item.target}>
                      {item.text}
                    </LinkHash>
                  ) : (
                    <NavLink to={item.href} className={`${item.class ? item.class : ""}`} target={item.target}>{item.text}</NavLink>
                  )}
                </div>
              ) : null
            )}
          </div>
          <div className="col-lg-4 col-md-6 col-12 p-3 customSectionFooter">
            <h5 className="text-uppercase header-footer mb-35">{t("Experiences")}</h5>
            {MenuLink.map((item, index) =>
              item.position === "Footer" && item.section === "Experiences" && item.show ? (
                <div key={index}>
                  {item.anchor ? (
                    <LinkHash className={`${item.class ? item.class : ""}`} smooth to={item.href} target={item.target}>
                      {item.text}
                    </LinkHash>
                  ) : (
                    <NavLink to={item.href} className={`${item.class ? item.class : ""}`} target={item.target}>{item.text}</NavLink>
                  )}
                </div>
              ) : null
            )}
          </div>
          <div className="col-lg-4 col-md-6 col-12 p-3 customSectionFooter">
            <h5 className="text-uppercase header-footer mb-35">{t("LegalArea")}</h5>
            {MenuLink.map((item, index) =>
              item.position === "Footer" && item.section === "LegalArea" && item.show ? (
                <div key={index}>
                  {item.href ? 
                  item.anchor ? (
                    <LinkHash className={`${item.class ? item.class : ""}`} smooth to={item.href} target={item.target}>
                      {item.text}
                    </LinkHash>
                  ) : (
                    <NavLink to={item.href} className={`${item.class ? item.class : ""}`} target={item.target}>{item.text}</NavLink>
                  ) : <p className={`text-uppercase ${item.class ? item.class : ""}`}>{item.text}</p>}
                </div>
              ) : null
            )}
          </div>
          
        </div>

        <div className="row pt-5 mt-5 px-3 borderBottSocial">
          <div className="col-lg-6 col-md-4 col-12 px-3 d-flex align-items-center">
            <NavLink target='_blank' to='https://www.facebook.com/FeelingItaly' className="socialLink"><FontAwesomeIcon icon={faFacebookF} /></NavLink>
            <NavLink target='_blank' to='https://www.instagram.com/feelingitaly/' className="socialLink"><FontAwesomeIcon icon={faInstagram} /></NavLink>
          </div>

          <div className="col-lg-6 col-md-8 col-12 customSectionFooter paymentSectionFooter">
          <div className="row mb-2">
            <div className="col-lg-8 col-md-6 col-12 d-flex align-items-center payment-text justify-content-end">
            <h5 className="text-uppercase header-footer fs-14 mb-0">{t("PaymentAccepted")}:</h5>
            </div>
            <div className="col-lg-4 col-md-6 col-12 d-flex align-items-center">
            <img src={paymentMethod} className="img-fluid w-100" alt="Payment Methods"/>
            </div>
            </div>
          </div>
        </div>

        <div className="row pt-3 pb-3 px-3">
          <div className="col-md-6 p-0 privacy-start">
            {MenuLink.map((item, index) =>
              item.position === "Footer" && item.section === "Copyright" && item.show ? (
                item.text === "Cookie Preferences" ? (
                  <button key={index} className="link text-white text-capitalize fs-14 lineEffect">
                    {item.text}
                  </button>
                ) : (
                  <NavLink key={index} to={item.href} className={`${item.class ? item.class : ""}`} target={item.target}>{item.text}</NavLink>
                )
              ) : null
            )}
          </div>
          <div className="col-md-6 p-0 copy-end">
            <p className="paragraph text-white copyright">
              &copy; Feeling Italy {new Date().getFullYear()}. {t("AllRightsReserved")}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
